import React from "react";

import Icon from "../Icon";
import AnimatedModal from "./AnimatedModal";

interface TypeformModalProps {
  close: () => void;
  visible: boolean;
  typeformLink: string;
}

const TypeformModal: React.FC<TypeformModalProps> = ({
  close,
  visible,
  typeformLink,
}) => {
  return (
    <AnimatedModal
      visible={visible}
      className="relative w-full sm:w-192 h-full sm:h-144 2xl:h-192 p-2"
    >
      <button
        className="focus:outline-none m-4 absolute top-0 right-0 z-20 font-medium text-dark"
        onClick={close}
      >
        <Icon className="text-2xl">close</Icon>
      </button>
      <section className="bg-white rounded-lg shadow-lg w-full h-full pt-4">
        <iframe
          title="longstays"
          id="typeform-full"
          width="100%"
          height="100%"
          src={typeformLink}
        ></iframe>
      </section>
    </AnimatedModal>
  );
};

export default TypeformModal;
